import { Box, ButtonGroup, Skeleton, Typography, Button, Tooltip } from "@mui/material";
import HorizontalSplitIcon from "@mui/icons-material/HorizontalSplit";
import VerticalSplitIcon from "@mui/icons-material/VerticalSplit";

const ProcedureComparisonSkeleton = () => (
  <Box p={2}>
    <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
      <Typography variant="h2" component="h2">
        <Skeleton width={240} />
      </Typography>
      <ButtonGroup variant="outlined" size="small" sx={{ ml: 2 }}>
        <Tooltip title="Side by Side View">
          <Button size="small" disabled>
            <VerticalSplitIcon />
          </Button>
        </Tooltip>
        <Tooltip title="Inline View">
          <Button size="small" disabled>
            <HorizontalSplitIcon />
          </Button>
        </Tooltip>
      </ButtonGroup>
    </Box>
  </Box>
);

export default ProcedureComparisonSkeleton;